import { Component, ElementRef, EventEmitter, Input, OnInit, Output, Renderer2, ViewChild } from '@angular/core';

@Component({
  selector: 'app-modal-info',
  templateUrl: './modal-info.component.html',
  styleUrls: ['./modal-info.component.css']
})
export class ModalInfoComponent implements OnInit {
  @Input() apretar_modal: boolean = false;
  @Input() info: any = {
                          nombre_modal: 'Modal-Info',
                          titulo: '',
                          descripcion: '',
                          boton_acepta: false,
                          label_acepta: '',
                          boton_cerrar: false,
                          label_cerrar: '',
                        };
  @Output() messageEvent = new EventEmitter<string>();
  cerrarModal: any;
  // @ViewChild('cerrarModal') cerrarModal: ElementRef;
  
  constructor(
    private renderer: Renderer2,
  ) { }

  ngOnInit(): void {
    let nombre_boton_modal = 'id_cerrar_' + this.info.nombre_modal;
    // //console.log(nombre_boton_modal);
    // this.cerrarModal = document.getElementById(nombre_boton_modal);
    // //console.log(this.cerrarModal);
    
  }
  
  ngOnChanges() {
    let nombre_boton_modal = 'id_cerrar_' + this.info.nombre_modal;
    // this.cerrarModal = document.getElementById(nombre_boton_modal);
    // this.cerrarModal.click();
    // document.getElementById(nombre_boton_modal).click();
    // //console.log(this.cerrarModal);
    
  }

  apretarModal() {
    this.cerrarModal.click();
  }

}
